import { Stack, Typography, useTheme } from "@mui/material";
import { CheckboxItem } from "./CheckboxItem";
import { useContext } from "react";
import { FeedbackContext, PriceFeedback } from "../context";

export const DoYouNeedCustomisedPlan = () => {
  const theme = useTheme();
  const context = useContext(FeedbackContext);
  if (!context) throw new Error("wrong context provided");
  const { priceFeedback, togglePriceFeedback } = context;

  const options = [
    {
      label: "I might",
      value: "might_consider_custom_plan",
    },
    {
      label: "No, I want to cancel",
      value: "want_to_cancel",
    },
  ];

  return (
    <Stack gap="12px">
      <Typography variant="body-medium" color={theme.palette.lightBg.low}>
        Would a customized offer or a better pricing plan make you reconsider?
      </Typography>
      <Stack direction="row" alignItems={"center"} gap="8px">
        {options.map((option) => (
          <CheckboxItem
            key={option.value}
            label={option.label}
            isChecked={priceFeedback === option.value}
            onClick={() => togglePriceFeedback(option.value as PriceFeedback)}
          />
        ))}
      </Stack>
    </Stack>
  );
};
